package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class CategoryQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    name: String,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(2_049_935_021, arrayOf("category"), driver, "Category.sq", "selectAll",
      "SELECT category.id, category.name, category.color, category.icon, category.order_index, category.created_at, category.updated_at, category.is_deleted, category.deleted_at, category.synced_at FROM category WHERE is_deleted = 0 ORDER BY order_index, name") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectAll(): Query<Category> = selectAll { id, name, color, icon, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Category(
      id,
      name,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectById(id: String, mapper: (
    id: String,
    name: String,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectById(id: String): Query<Category> = selectById(id) { id_, name, color, icon,
      order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Category(
      id_,
      name,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    name: String,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-1_399_743_010, arrayOf("category"), driver, "Category.sq",
      "selectDirty",
      "SELECT category.id, category.name, category.color, category.icon, category.order_index, category.created_at, category.updated_at, category.is_deleted, category.deleted_at, category.synced_at FROM category WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectDirty(): Query<Category> = selectDirty { id, name, color, icon, order_index,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Category(
      id,
      name,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    name: String,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getString(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getLong(6)!!,
      cursor.getLong(7)!!,
      cursor.getLong(8),
      cursor.getLong(9)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Category> = selectByIdAnyState(id) { id_, name,
      color, icon, order_index, created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Category(
      id_,
      name,
      color,
      icon,
      order_index,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    name: String,
    color: String,
    icon: String,
    order_index: Long,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_673_988_079, """
        |INSERT INTO category(id, name, color, icon, order_index, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 7) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, color)
          bindString(3, icon)
          bindLong(4, order_index)
          bindLong(5, created_at)
          bindLong(6, updated_at)
        }
    notifyQueries(-1_673_988_079) { emit ->
      emit("category")
    }
  }

  public fun update(
    name: String,
    color: String,
    icon: String,
    order_index: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_329_041_887, """
        |UPDATE category
        |SET name = ?, color = ?, icon = ?, order_index = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 6) {
          bindString(0, name)
          bindString(1, color)
          bindString(2, icon)
          bindLong(3, order_index)
          bindLong(4, updated_at)
          bindString(5, id)
        }
    notifyQueries(-1_329_041_887) { emit ->
      emit("category")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(184_412_109,
        """UPDATE category SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""", 3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(184_412_109) { emit ->
      emit("category")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(-1_213_642_698,
        """UPDATE category SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""", 2)
        {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(-1_213_642_698) { emit ->
      emit("category")
    }
  }

  public fun hardDelete(id: String) {
    driver.execute(4_349_902, """DELETE FROM category WHERE id = ?""", 1) {
          bindString(0, id)
        }
    notifyQueries(4_349_902) { emit ->
      emit("category")
      emit("objective")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(1_387_305_727,
        """UPDATE category SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(1_387_305_727) { emit ->
      emit("category")
    }
  }

  private inner class SelectByIdQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("category", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("category", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-876_482_490,
        """SELECT category.id, category.name, category.color, category.icon, category.order_index, category.created_at, category.updated_at, category.is_deleted, category.deleted_at, category.synced_at FROM category WHERE id = ? AND is_deleted = 0""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Category.sq:selectById"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("category", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("category", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(467_950_699,
        """SELECT category.id, category.name, category.color, category.icon, category.order_index, category.created_at, category.updated_at, category.is_deleted, category.deleted_at, category.synced_at FROM category WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "Category.sq:selectByIdAnyState"
  }
}
